import { render } from "./DeleteUserModal.vue?vue&type=template&id=2422c972&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"

import "./DeleteUserModal.vue?vue&type=style&index=0&id=2422c972&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2422c972"]])

export default __exports__